var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#1e252c",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22 15.589a1.507 1.507 0 110-3.014 1.507 1.507 0 010 3.014zm3.698 0a1.507 1.507 0 110-3.014 1.507 1.507 0 010 3.014zm-3.699 3.699a1.507 1.507 0 110-3.014 1.507 1.507 0 010 3.014zm3.699 0a1.507 1.507 0 110-3.014 1.507 1.507 0 010 3.014zm3.698-4.11a1.096 1.096 0 110-2.192 1.096 1.096 0 010 2.192zm0 3.699a1.096 1.096 0 110-2.192 1.096 1.096 0 010 2.192zm-11.232-3.699a1.096 1.096 0 110-2.192 1.096 1.096 0 010 2.192zm0 3.699a1.096 1.096 0 110-2.192 1.096 1.096 0 010 2.192zm3.835 3.698a1.096 1.096 0 110-2.191 1.096 1.096 0 010 2.191zm3.699 0a1.096 1.096 0 110-2.191 1.096 1.096 0 010 2.191zM14.219 11.48a1.096 1.096 0 110-2.191 1.096 1.096 0 010 2.191zm3.699 0a1.096 1.096 0 110-2.191 1.096 1.096 0 010 2.191zm-3.699-4.11a.685.685 0 110-1.369.685.685 0 010 1.37zm3.699 0a.685.685 0 110-1.369.685.685 0 010 1.37zm7.397 7.398a.685.685 0 110-1.37.685.685 0 010 1.37zm0 3.699a.685.685 0 110-1.37.685.685 0 010 1.37zm-18.63-3.699a.685.685 0 110-1.37.685.685 0 010 1.37zm0 3.699a.685.685 0 110-1.37.685.685 0 010 1.37zM14.219 26a.685.685 0 110-1.37.685.685 0 010 1.37zm3.699 0a.685.685 0 110-1.37.685.685 0 010 1.37z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMds);
export default __webpack_public_path__ + "static/media/mds.91a352e7198d3f4d290fcdce462a3b31.svg";
export { ForwardRef as ReactComponent };